import { Record } from 'immutable';
import Util from '../util';
import { AREA_TEXTS, COLLEGE_TYPE_TEXTS, MAJOR_TYPE_TEXTS, MARRIAGE_TEXTS, NATIONALITY_TEXTS, RACE_TEXTS } from '../consts';

export type ApiDonorBasicInfo = {
  birth_date: string;
  college_type: string;
  major_type: string;
  college: string;
  major: string;
  marriage: string;
  son: number;
  daughter: number;
  comments: string;
  is_public: boolean;
  areas: string[];
  nationality: string;
  race: string;
};

const DonorBasicInfoBase = Record({
  birthDate: "",
  collegeType: "",
  majorType: "",
  college: "",
  major: "",
  marriage: "",
  son: 0,
  daughter: 0,
  comments: "",
  isPublic: false,
  areas: [] as string[],
  nationality: "",
  race: "",
});

export class DonorBasicInfo extends DonorBasicInfoBase {
  constructor(apiDonorBasicInfo?: ApiDonorBasicInfo) {
    super({
      birthDate: apiDonorBasicInfo?.birth_date,
      collegeType: apiDonorBasicInfo?.college_type,
      majorType: apiDonorBasicInfo?.major_type,
      college: apiDonorBasicInfo?.college,
      major: apiDonorBasicInfo?.major,
      marriage: apiDonorBasicInfo?.marriage,
      son: apiDonorBasicInfo?.son || 0,
      daughter: apiDonorBasicInfo?.daughter || 0,
      comments: apiDonorBasicInfo?.comments,
      isPublic: apiDonorBasicInfo?.is_public,
      areas: apiDonorBasicInfo?.areas,
      nationality: apiDonorBasicInfo?.nationality,
      race: apiDonorBasicInfo?.race
    })
  }

  readonly age: number = this.birthDate ? Util.getAge(this.birthDate) : 0;

  readonly areasText: string[] = this.areas.map(v => AREA_TEXTS[v]).filter(v => v);

  readonly collegeTypeText: string = COLLEGE_TYPE_TEXTS[this.collegeType];

  readonly majorTypeText: string = MAJOR_TYPE_TEXTS[this.majorType];

  readonly marriageText: string = MARRIAGE_TEXTS[this.marriage];

  readonly nationalityText: string = NATIONALITY_TEXTS[this.nationality];

  readonly raceText: string = RACE_TEXTS[this.race];
}
